import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import Home from '../components/home';
import React from 'react';
import Search from '../components/search';
import Scan from '../components/scan';
import Results from '../components/results';
import AboutWebApp from '../components/about_web_app';
import ChangePassword from '../components/change_password/change_password';
import NotFoundUrl from '../components/not_found_url/not_found_url';
import { useSelector } from 'react-redux';
import LoginParent from '../components/login/login_parent';
import RegisterParent from '../components/register/register_parent';

export default function Routers() {
    const isScan = useSelector((state) => state.general_reducer.isScan);

    return (
        <BrowserRouter>
            <Routes>
                <Route exact path='/' element={<Home />} />
                <Route exact path='/login' element={<LoginParent />} />
                <Route exact path='/register' element={<RegisterParent />} />
                <Route exact path='/search' element={<Search />} />
                <Route exact path='/search/:hash' element={<Search />} />
                <Route exact path='/scan' element={<Scan />} />
                {/* {i exactsScan && <Route path='/results' element={<Results />} />} */}
                <Route  path='/results' element={<Results />} />
                <Route exact path='/aboutApp' element={<AboutWebApp />} />
                <Route exact path='/changePassword' element={<ChangePassword />} />
                <Route exact path="*" element={<NotFoundUrl />} />
            </Routes>
        </BrowserRouter>
    )
}

